<div class="modal-header">
    <button type="button" id="js-btn-close" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Konfiguration importieren"}}</h4>
</div>

<div class="modal-body">
	<div class="row">
	<div class="col-xs-12">
		<label>{{TR 'Quellgerät von dem Einstellungen zum aktuellen Gerät übertragen werden sollen.'}}</label>
		{{#DEVICE_SELECT sourceDeviceID}}
		<select id="js-device-select" />
		{{/DEVICE_SELECT}}
	</div>
	</div>

        {{#if sourceDeviceID}}
	<div class="row">
	<div class="col-xs-12">
		<p class="m-b-10 m-t-20">
		{{TR "Wählen Sie die Konfigurationseinstellungen, die Sie vom Quellgerät in dieses Gerät übertragen möchten."}}
		</p>
	</div>
	</div>

	{{#each elements}}
	<div class="row">
	<div class="col-xs-11 col-xs-offset-1">
		<div class="checkbox checkbox-primary">
			<input id="js-copy-{{id}}" class="js-copy-toggle" type="checkbox" {{#if isEnabled}}checked="checcked"{{/if}}>
			<label for="js-copy-{{id}}">{{text}}</label>
		</div>
	</div>
	</div>
	{{/each}}

	<div class="row">
	<div class="col-xs-12">
		<div class="alert alert-danger m-t-20">
			<strong>{{TR "Die ausgewählten Einstellungen werden überschrieben."}}</strong>
		</div>
	</div>
	</div>
	{{/if}}
</div>

<div class="modal-footer">
    <button id="js-btn-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button id="js-btn-save" class="btn btn-primary"{{#unless sourceDeviceID}} disabled{{/unless}}{{#unless hasSelection}} disabled{{/unless}}>
        {{TR "Importieren"}}
    </button>
</div>
